"use strict";
/* globals module */
/**
 * @module mediaGalleryInstanceFilesRoute
 * @description Baasic Media Gallery Instance Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var __1 = require("../");
var MediaGalleryInstanceFilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryInstanceFilesRoute, _super);
    function MediaGalleryInstanceFilesRoute(mediaGalleryInstanceFilesBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.mediaGalleryInstanceFilesBatchRoute = mediaGalleryInstanceFilesBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'media-galleries/{mediaGalleryId}/files/{?searchQuery,fileName,minFileSize,maxFileSize,ids,from,to,page,rpp,sort,embed,fields}';
        _this.getRoute = 'media-galleries/{mediaGalleryId}/files/{id}/{?embed,fields}';
        _this.linkRoute = 'media-galleries/{mediaGalleryId}/files/link';
        _this.unlinkRoute = 'media-galleries/{mediaGalleryId}/files/unlink/{id}';
        _this.unlinkByMediaGalleryRoute = 'media-galleries/{mediaGalleryId}/files/unlink';
        _this.updateRoute = 'media-galleries/{mediaGalleryId}/files/{id}';
        return _this;
    }
    Object.defineProperty(MediaGalleryInstanceFilesRoute.prototype, "batch", {
        get: function () {
            return this.mediaGalleryInstanceFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param mediaGalleryId Media Gallery slug or id which uniquely identifies media gallery whose media gallery files need to be retrieved.
     * @param options Query resource options object.
     * @example mediaGalleryInstanceFilesRoute.find({searchQuery: '<search-phrase>'});
     **/
    MediaGalleryInstanceFilesRoute.prototype.find = function (mediaGalleryId, options) {
        var params = this.modelMapper.findParams(options);
        params.mediaGalleryId = mediaGalleryId;
        return _super.prototype.baseGet.call(this, this.findRoute, params);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery files need to be retrieved.
     * @param id Media Gallery file id which uniquely identifies media gallery file that needs to be retrieved.
     * @param options options object that contains embed data.
     * @example mediaGalleryInstanceFilesRoute.get({id: '<file-id>'});
     **/
    MediaGalleryInstanceFilesRoute.prototype.get = function (mediaGalleryId, id, options) {
        var params = this.utility.extend({}, options);
        params.mediaGalleryId = mediaGalleryId;
        params.id = id;
        return _super.prototype.baseGet.call(this, this.getRoute, params);
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery files need to be deleted.
     * @param data
     * @param options
     * @example mediaGalleryInstanceFilesRoute.link();
     **/
    MediaGalleryInstanceFilesRoute.prototype.link = function (mediaGalleryId, data) {
        var params = this.utility.extend({}, data);
        params.mediaGalleryId = mediaGalleryId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies gallery whose gallery files need to be deleted.
     * @param data
     * @example mediaGalleryFilesRoute.unlink(mediaGalleryId,data);
     **/
    MediaGalleryInstanceFilesRoute.prototype.unlink = function (mediaGalleryId, data) {
        data.mediaGalleryId = mediaGalleryId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data);
    };
    /**
     * Parses unlink by media gallery route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery files need to be deleted.
     * @param data
     * @param options
     * @example mediaGalleryFilesRoute.unlinkByMediaGallery(data);
     **/
    MediaGalleryInstanceFilesRoute.prototype.unlinkByMediaGallery = function (mediaGalleryId, options) {
        return _super.prototype.baseDelete.call(this, this.unlinkByMediaGalleryRoute, mediaGalleryId, options, 'unlink-by-media-gallery');
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example mediaGalleryInstanceFilesRoute.update(data);
     **/
    MediaGalleryInstanceFilesRoute.prototype.update = function (mediaGalleryId, data) {
        var params = this.modelMapper.updateParams(data);
        params.mediaGalleryId = mediaGalleryId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    var _a, _b;
    MediaGalleryInstanceFilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.MediaGalleryInstanceFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.MediaGalleryInstanceFilesBatchRoute !== "undefined" && __1.MediaGalleryInstanceFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], MediaGalleryInstanceFilesRoute);
    return MediaGalleryInstanceFilesRoute;
}(common_1.BaseRoute));
exports.MediaGalleryInstanceFilesRoute = MediaGalleryInstanceFilesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 
